// extracted by mini-css-extract-plugin
export var content = "_mf-1";
export var fullScreen = "_mf-0";